// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__138FG","dragIcon":"SortableItem_dragIcon__2ocZd","disabled":"SortableItem_disabled__WI4bK"};